import Vue from 'vue';
import Router from 'vue-router';
import Staff from './views/Staff.vue';
import Employes from './views/Employes.vue';
import Horaires from './views/Horaires.vue';
import CineStaff from './views/CineStaff.vue';
import HorairesGeneral from './views/HorairesGeneral.vue';
import HorairesParEmploye from './views/HorairesParEmploye.vue';
import Heures from './views/Heures.vue';
import HeuresGestion from './views/HeuresGestion.vue';
import HeuresConsulter from './views/HeuresConsulter.vue';
import Remplacements from './views/Remplacements.vue';
import Help from './views/Help.vue';
import NotFound from './views/NotFound.vue';
import Modele from './views/Modele.vue';
import Modeles from './views/Modeles.vue';
import Vacances from './views/Vacances.vue';
import Login from './views/Login.vue';
import QSP from './views/QSP.vue';
import Settings from './views/Settings.vue';
import HorairesGestion from './views/HorairesGestion.vue';
import HorairesModification from './views/HorairesModification.vue';
import Particularites from './views/Particularites.vue';
import Particularite from './views/Particularite.vue';
import { requireAuth } from './auth';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/partic',
      name: 'Particularites',
      component: Particularites,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/partic/:id',
      name: 'Particularite',
      component: Particularite,
      beforeEnter: requireAuth,
    },
    {
      path: '/staff',
      name: 'staff',
      component: Staff,
      beforeEnter: requireAuth,
    },
    {
      path: '/staff/employes',
      name: 'employes',
      component: Employes,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires',
      name: 'horaires',
      component: Horaires,
      beforeEnter: requireAuth,
    },
    {
      path : '/horaires/employe',
      name : "horairesParEmploye",
      component : HorairesParEmploye,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/modeles/:id',
      name: 'modele',
      component: Modele,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/modeles',
      name: 'modeles',
      component: Modeles,
      beforeEnter: requireAuth,
    },
    {
      path: '/cinestaff',
      name: 'cinestaff',
      component: CineStaff,
      beforeEnter: requireAuth,
    },
    {
      path: '/cinestaff/remplacements',
      name: 'remplacements',
      component: Remplacements,
      beforeEnter: requireAuth,
    }, {
      path: '/cinestaff/qsp',
      name: 'qsp',
      component: QSP,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/general',
      name: 'horaires_general',
      component: HorairesGeneral,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/gestion',
      name: 'horaires_gestion',
      component: HorairesGestion,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/modification',
      name: 'horaires_modification',
      component: HorairesModification,
      beforeEnter: requireAuth,
    },
    {
      path: '/horaires/modification/:id',
      name: 'horaires_modification_id',
      component: HorairesModification,
      beforeEnter: requireAuth,
    },
    {
      path: '/heures',
      name: 'heures',
      component: Heures,
      beforeEnter: requireAuth,
    },
    {
      path: '/heures/gestion',
      name: 'heuresgestion',
      component: HeuresGestion,
      beforeEnter: requireAuth,
    },
    {
      path: '/heures/consulter',
      name: 'heuresconsulter',
      component: HeuresConsulter,
      beforeEnter: requireAuth,
    },
    {
      path: '/aide',
      name: 'aide',
      component: Help,
      beforeEnter: requireAuth,
    }, {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter: requireAuth,
    },
    {
      path: '/vacances',
      name: 'vacances',
      component: Vacances,
      beforeEnter: requireAuth,
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
      beforeEnter: requireAuth,
    }
  ]
})
